import { useState, useEffect } from 'react';
import Login from './Login';
import Dashboard from './Dashboard';
import TirSefer from './TirSefer';
import Depo from './depo';
import Gumruk from './gumruk';
import Musteriler from './musteriler';
import Teslimat from './Teslimat';
import Odemeler from './Odemeler';
import Kullanicilar from './Kullanicilar';
import IhracatSihirbazi from './IhracatSihirbazi';
import SurucuPanel from './SurucuPanel';
import MusteriTakip from './MusteriTakip';
import MuhasebeciPanel from './MuhasebeciPanel';
import DagitimciPanel from './DagitimciPanel';

function App() {
  const [kullanici, setKullanici] = useState(null);
  const [aktivSayfa, setAktivSayfa] = useState('dashboard');

  useEffect(() => {
    const kayitliKullanici = localStorage.getItem('kullanici');
    if (kayitliKullanici) {
      const k = JSON.parse(kayitliKullanici);
      setKullanici(k);
      // Operasyon rolü: dashboard yerine TIR/Sefer ile başla
      if (k.rol === 'operasyon')  setAktivSayfa('tirsefer');
      // Muhasebeci rolü: direkt ödemeler ile başla
      if (k.rol === 'muhasebeci') setAktivSayfa('odemeler');
    }
  }, []);

  // Genel takip sayfası — giriş gerekmez
  if (window.location.pathname === '/takip') {
    return <MusteriTakip />;
  }

  const cikisYap = () => {
    localStorage.removeItem('kullanici');
    setKullanici(null);
    setAktivSayfa('dashboard');
  };

  const sayfaGoster = () => {
    switch (aktivSayfa) {
      case 'dashboard': return <Dashboard />;
      case 'tirsefer': return <TirSefer />;
      case 'depo': return <Depo kullanici={kullanici} />;
      case 'gumruk': return <Gumruk />;
      case 'musteriler': return <Musteriler />;
      case 'teslimat': return <Teslimat />;
      case 'odemeler': return <Odemeler />;
      case 'kullanicilar': return <Kullanicilar />;
      case 'ihracatsihirbazi': return <IhracatSihirbazi />;
      case 'surucu': return <SurucuPanel />;
      default: return <Dashboard />;
    }
  };

  // Rol bazlı menü
  const menuItems = () => {
    const rol = kullanici?.rol;
    const tumMenu = [
      { key: 'dashboard',    label: 'Gösterge Paneli' },
      { key: 'tirsefer',     label: 'TIR / Sefer' },
      { key: 'depo',         label: 'Depo' },
      { key: 'gumruk',       label: 'Gümrük' },
      { key: 'musteriler',   label: 'Müşteriler' },
      { key: 'teslimat',     label: 'Teslimat' },
      { key: 'odemeler',     label: 'Ödemeler' },
      { key: 'kullanicilar',     label: 'Kullanıcılar' },
      { key: 'ihracatsihirbazi', label: 'İhracat Sihirbazı' },
    ];

    if (rol === 'yonetici')    return tumMenu;
    if (rol === 'operasyon')   return tumMenu.filter(m => ['tirsefer', 'depo', 'gumruk', 'teslimat', 'ihracatsihirbazi'].includes(m.key));
    if (rol === 'dagitimci')   return tumMenu.filter(m => m.key === 'teslimat');
    if (rol === 'depo')        return tumMenu.filter(m => m.key === 'depo');
    if (rol === 'muhasebeci')  return tumMenu.filter(m => m.key === 'odemeler');
    if (rol === 'surucu')      return [{ key: 'surucu', label: 'Seferlerim' }];
    if (rol === 'musteri')     return [];
    return [];
  };

  if (!kullanici) {
    return <Login onLogin={(k) => {
      setKullanici(k);
      // Operasyon rolü: dashboard yerine TIR/Sefer ile başla
      if (k.rol === 'operasyon')  setAktivSayfa('tirsefer');
      // Muhasebeci rolü: direkt ödemeler ile başla
      if (k.rol === 'muhasebeci') setAktivSayfa('odemeler');
    }} />;
  }

  // Sürücü rolü için tamamen farklı (sidebar'sız) layout
  if (kullanici.rol === 'surucu') {
    return <SurucuPanel onCikis={cikisYap} />;
  }

  // Dağıtımcı rolü için sidebar'sız, sadece teslimat paneli
  if (kullanici.rol === 'dagitimci') {
    return <DagitimciPanel onCikis={cikisYap} />;
  }

  // Depo görevlisi rolü için sidebar'sız, sadece depo paneli
  if (kullanici.rol === 'depo') {
    return <Depo onCikis={cikisYap} kullanici={kullanici} />;
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sol Menü */}
      <div style={{
        width: '220px', background: '#1a3a6b', color: 'white',
        display: 'flex', flexDirection: 'column', padding: '0'
      }}>
        <div style={{ padding: '20px 16px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <img src="/logo.png" alt="BYR SWORD" style={{ width: '130px', objectFit: 'contain', borderRadius: '6px' }} />
        </div>

        <nav style={{ flex: 1, padding: '16px 0' }}>
          {menuItems().map(item => (
            <div
              key={item.key}
              onClick={() => setAktivSayfa(item.key)}
              style={{
                padding: '12px 16px', cursor: 'pointer', fontSize: '14px',
                background: aktivSayfa === item.key ? 'rgba(255,255,255,0.15)' : 'transparent',
                borderLeft: aktivSayfa === item.key ? '3px solid #4CAF50' : '3px solid transparent',
                transition: 'all 0.2s'
              }}
            >
              {item.label}
            </div>
          ))}
        </nav>

        <div style={{ padding: '16px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ fontSize: '13px', color: '#a0b4d0', marginBottom: '8px' }}>
            {kullanici.ad}
          </div>
          <div style={{ fontSize: '11px', color: '#7a94b0', marginBottom: '12px' }}>
            {kullanici.rol}
          </div>
          <button
            onClick={cikisYap}
            style={{
              width: '100%', padding: '8px', background: 'rgba(255,255,255,0.1)',
              color: 'white', border: '1px solid rgba(255,255,255,0.2)',
              borderRadius: '6px', cursor: 'pointer', fontSize: '13px'
            }}
          >
            Çıkış Yap
          </button>
        </div>
      </div>

      {/* Sağ İçerik */}
      <div style={{ flex: 1, background: '#f5f7fa', overflow: 'auto' }}>
        {sayfaGoster()}
      </div>
    </div>
  );
}

export default App;